<div
  class="bg-warning p-1 d-flex align-items-center justify-content-center"
  *ngIf="showOnboardingBanner && !this.isHideOnboardingUrl"
>
  <span class="fw-bold me-3">{{ 'onboarding.notFinishedMessage' | translate }}</span>
  <base-button
    class="d-inline-block my-0"
    label="onboarding.showMeWhatToDoButton"
    [size]="buttonSize.xs"
    color="dark"
    (btnClick)="callOnboardingModal()"
  ></base-button>
</div>
<ng-template #baseOnboardingLight>
  <base-customer-onboarding-light
    [logo]="logo"
    [application]="application"
    [modalRef]="modalRef"
  ></base-customer-onboarding-light>
</ng-template>
